import React from "react";
import {
  translate
} from "admin-on-rest";
import SimpleForm from "../../../components/CRM/Form/SimpleCreateGiftCardForm";
import CreateGiftCard from "../../../components/CRM/CreateGiftCard";

import restClient from "../../../restClient";
import {giftCardForm} from "./style";
import {validateCustomerData} from "./validations";

class GiftCardCreateForm extends React.Component {
  state = {
    record: null,
    total: null,
    kioskPromos: null,
    page: 1,
    perPage: 10,
    sort: {field: "name", order: "ASC"},
    partnerPhone: null,
    disabledInputFields: false,
    date: null,
    showEmptyFields: false,
    userChecked: false,
    value: 10000,
    promo_id: null
  };

  componentDidMount() {
    let d = new Date();
    let dateString = d.getUTCDate() +"/"+ (d.getUTCMonth()+1) +"/"+ d.getUTCFullYear();
    this.setState({ date: dateString });

    const {page, perPage, sort} = this.state;

    const kiosk = JSON.parse(localStorage.getItem("kiosk"));
    const kiosk_id = kiosk ? kiosk.id : '';

    const reference = `kiosks/${kiosk_id}/giftcard_promotions`;
    const pagination = {page: page, perPage: perPage};
    
    this.getKioskPromos(pagination, sort, reference);
  }

  getCustomer(pagination, sort, reference, filter = {phone: this.state.partnerPhone}) {
    if(this.state.partnerPhone){
      restClient("GET_LIST", "customers", {
        pagination: {...pagination},
        sort: sort,
        filter: filter
      }).then(({data, total}) => {
        if(data && data.length > 0){
          this.setState(
            {
              record: data[0],
              disabledInputFields: true,
              showEmptyFields: false
          });
        } else {
          this.setState({ showEmptyFields: true, disabledInputFields: false });
        }
      }).catch(error => {
        console.debug(error);
      });
    }    
  }

  getKioskPromos(pagination, sort, reference, filter = ''){
    restClient("GET_LIST", reference, {
      pagination: {...pagination},
      sort: sort,
      filter: filter
    }).then(({data, total}) => {
      const promoChoices = data ? data.map(promo => {
        let promoObject = {
          id: promo.id,
          name: promo.name
        };
        return promoObject;
      }) : [];
      
      this.setState({
        kioskPromos: promoChoices,
        promo_id: (promoChoices && promoChoices.length > 0) ? promoChoices[0].id : null
      })
    }).catch(error => {
      console.debug(error);
    });
  }

  checkCustomer = () => {
    this.setState({ userChecked: true });
    const {page, perPage, sort} = this.state;
    const reference = "customers";
    const pagination = {page: page, perPage: perPage};
    this.getCustomer(pagination, sort, reference);
  }

  inputPhoneNumberChange = (event) => {
    this.setState({
      record: null,
      userChecked: false,
      showEmptyFields: false
    });
    const val = event.target.value;
    if (val !== '' && val !== undefined) {
      this.setState({
        partnerPhone: val
      });
    } else {
      this.setState({ showEmptyFields: false, userChecked: false });
    }
  }
  
  render() {
    const props = {...this.props};
    const {
      record,
      disabledInputFields,
      kioskPromos,
      showEmptyFields,
      userChecked,
      value,
      promo_id
    } = this.state;
    
    var defaultValues = record ? { phone: record.phone, customer_id: record.id, first_name: record.first_name, last_name: record.last_name, email: record.email, state: "new", value: value, promo_id: promo_id } : { state: "new", value: 10000, promo_id: promo_id };

    const PostTitle = ({ record }) => {
      return <span style={giftCardForm.titleDivider}>{this.props.translate("resources.giftCards.createGiftCard")}</span>;
    };
    
    return (
      <CreateGiftCard 
        {...props}
      >        
        <SimpleForm 
          title={<PostTitle />}
          redirect="edit" 
          validate={validateCustomerData} 
          style={giftCardForm.form}
          defaultValue={defaultValues}
          giftCardForm={giftCardForm}
          disabledInputFields={disabledInputFields}
          checkCustomer={this.checkCustomer}
          inputPhoneNumberChange={this.inputPhoneNumberChange}
          location={this.props.location}
          kioskPromos={kioskPromos}
          existingCustomer={record}
          showEmptyFields={showEmptyFields}
          userChecked={userChecked}
        >        
        </SimpleForm>        
      </CreateGiftCard>
    );
  }
}

export default translate(GiftCardCreateForm);



// WEBPACK FOOTER //
// ./src/containers/CRM/GiftCards/GiftCardCreateForm.js